// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOrganizationLogoDto } from './IOrganizationLogoDto';
import {
    IOrganizationLogoDtoFromJSON,
    IOrganizationLogoDtoFromJSONTyped,
    IOrganizationLogoDtoToJSON,
    IOrganizationLogoDtoToJSONTyped,
} from './IOrganizationLogoDto';

/**
 * 
 * @export
 * @interface IQrCodeOverridablePropertiesDto
 */
export interface IQrCodeOverridablePropertiesDto {
    /**
     * 
     * @type {string}
     * @memberof IQrCodeOverridablePropertiesDto
     */
    partner_mobile_app?: IQrCodeOverridablePropertiesDtoPartnerMobileAppEnum;
    /**
     * 
     * @type {string}
     * @memberof IQrCodeOverridablePropertiesDto
     */
    partner_app_ios_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IQrCodeOverridablePropertiesDto
     */
    partner_app_android_link?: string;
    /**
     * 
     * @type {IOrganizationLogoDto}
     * @memberof IQrCodeOverridablePropertiesDto
     */
    logo_info?: IOrganizationLogoDto;
}

/**
* @export
* @enum {string}
*/
export enum IQrCodeOverridablePropertiesDtoPartnerMobileAppEnum {
    NONE = 'NONE',
    ELEVATE_APP = 'ELEVATE_APP',
    PARTNER_OWN_APP = 'PARTNER_OWN_APP'
}


/**
 * Check if a given object implements the IQrCodeOverridablePropertiesDto interface.
 */
export function instanceOfIQrCodeOverridablePropertiesDto(value: object): value is IQrCodeOverridablePropertiesDto {
    return true;
}

export function IQrCodeOverridablePropertiesDtoFromJSON(json: any): IQrCodeOverridablePropertiesDto {
    return IQrCodeOverridablePropertiesDtoFromJSONTyped(json, false);
}

export function IQrCodeOverridablePropertiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IQrCodeOverridablePropertiesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'partner_mobile_app': json['partner_mobile_app'] == null ? undefined : json['partner_mobile_app'],
        'partner_app_ios_link': json['partner_app_ios_link'] == null ? undefined : json['partner_app_ios_link'],
        'partner_app_android_link': json['partner_app_android_link'] == null ? undefined : json['partner_app_android_link'],
        'logo_info': json['logo_info'] == null ? undefined : IOrganizationLogoDtoFromJSON(json['logo_info']),
    };
}

export function IQrCodeOverridablePropertiesDtoToJSON(json: any): IQrCodeOverridablePropertiesDto {
    return IQrCodeOverridablePropertiesDtoToJSONTyped(json, false);
}

export function IQrCodeOverridablePropertiesDtoToJSONTyped(value?: IQrCodeOverridablePropertiesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partner_mobile_app': value['partner_mobile_app'],
        'partner_app_ios_link': value['partner_app_ios_link'],
        'partner_app_android_link': value['partner_app_android_link'],
        'logo_info': IOrganizationLogoDtoToJSON(value['logo_info']),
    };
}

